export default __webpack_public_path__ + "static/media/BIR_Registered.775642dd.webp";